import React from 'react';
import { BarChart3Icon, BotIcon, CopyIcon, LayersIcon, PiggyBankIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = [{
  label: 'Spot',
  Icon: BarChart3Icon
}, {
  label: 'Derivados',
  Icon: LayersIcon
}, {
  label: 'Copy Trading',
  Icon: CopyIcon
}, {
  label: 'Earn',
  Icon: PiggyBankIcon
}, {
  label: 'Bot Trading',
  Icon: BotIcon
}, {
  label: 'Herramientas',
  Icon: WrenchIcon
}];
export function CategoryBar() {
  return <section id="mercados" className="border-y border-hairline bg-surface/60 px-5 py-12 lg:px-8" data-id="element-16" data-mp="2p7hxmj2l4u8u">
      <div className="mx-auto max-w-shell" data-id="element-17" data-mp="2tyq7fg7tuhmj">
        <Reveal data-id="element-18" data-mp="2tzrihkouf449">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-ink-muted" data-id="element-19" data-mp="2tz9okupnl1zi">
            Explora el ecosistema crypto
          </h2>
        </Reveal>
        <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-20" data-mp="3307iulaahv4w">
          {items.map(({
          label,
          Icon
        }, i) => <Reveal as="li" key={label} delay={i * 0.04} data-id="element-21" data-mp="37yixd9bj4ttg" data-mpi={i}>
              <div className="group flex h-full items-center gap-3 rounded-2xl border border-hairline bg-card/70 px-4 py-4 transition-[border-color,background-color] duration-200 ease-smooth hover:border-brand/40 hover:bg-card" data-id="element-22" data-mp="17ktwqhbbikyq">
                <Icon className="h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-smooth group-hover:scale-110" aria-hidden="true" data-id="element-23" data-mp="ykf93bavsts2" />
                <span className="text-[13px] font-medium text-white" data-id="element-24" data-mp="1qaa15fq4ixkf">{label}</span>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}